import { useEffect, useState } from 'react'

export interface InstructorSummary {
  id: string
  name: string
  image_url: string | null
  ride_count: number
}

export function useAllInstructors() {
  const [data, setData] = useState<InstructorSummary[] | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false

    fetch('/api/instructors', { headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) throw new Error(`Request failed: ${response.status}`)
        return response.json() as Promise<InstructorSummary[]>
      })
      .then((json) => {
        if (!cancelled) setData(json)
      })
      .catch((err) => {
        if (!cancelled) setError(err instanceof Error ? err.message : 'Failed to load instructors')
      })

    return () => {
      cancelled = true
    }
  }, [])

  return { data, error }
}
